/**
 * Canonical character primary key across AppContext (init) and inventory sheet DTOs.
 * Context uses `characterId`; inventory historically used `id`.
 */
export function getCharacterId(character) {
  if (!character || typeof character !== 'object') return null
  const raw = character.characterId ?? character.id ?? character._id
  const n = Number(raw)
  return Number.isFinite(n) && n > 0 ? n : null
}

/** @deprecated Prefer getCharacterId — kept for adventure reply call sites */
export function resolveCharacterId(character) {
  return getCharacterId(character)
}
